
export {Children,
Component,
Fragment,
Profiler,
PureComponent,
StrictMode,
Suspense,
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
cloneElement,
createContext,
createElement,
createFactory,
createRef,
forwardRef,
isValidElement,
lazy,
memo,
startTransition,
unstable_act,
useCallback,
useContext,
useDebugValue,
useDeferredValue,
useEffect,
useId,
useImperativeHandle,
useInsertionEffect,
useLayoutEffect,
useMemo,
useReducer,
useRef,
useState,
useSyncExternalStore,
useTransition,
version} from '../../../frontend-js-react-web/__liferay__/exports/react.js';
import __x__ from '../../../frontend-js-react-web/__liferay__/exports/react.js';export default __x__;